
import { getAxiosNotif, getAxiosTotall } from "./ApiInstance"

/////////////////  Get Method  ////////////////////
export const getRateApi=async()=>{
    try{
        const result = await getAxiosTotall().get("statistics/rate/")
        return result.data
    }catch(error){
        return error
    }
}
export const getCategoryDiscountApi=async()=>{
    try{
        const result = await getAxiosTotall().get("category/all/")
        return result.data
    }catch(error){
        return error
    }
}
export const getImagesAPi=async(id)=>{
    try{
        const result = await getAxiosTotall().get(`products/detail/${id}/`)
        return result.data
    }catch(error){
        return error
    }
}
export const getSupplierPAgeAPi=async()=>{
    try{
        const result = await getAxiosTotall().get(`profile/edit/`)
        return result.data
    }catch(error){
        return error
    }
}
export const getAcountingAPi=async()=>{
    try{
        const result = await getAxiosTotall().get('statistics/all/')
        return result.data
    }catch(error){
        return error
    }
} 

export const getSupplierInfoAPi=(callback)=>{
    getAxiosTotall().get("profile/info/").then(response =>{
        if(response.data.status===-2&&localStorage.getItem('JwtTokens')!==null){
            localStorage.clear()
            window.location.reload()
        }else{
            callback(true,response.data)
        }
    }).catch(error => {
        callback(false,error.data);
    })
} 

export const getFoodCategoryAPi=async()=>{
    try{
        const result = await getAxiosTotall().get('profile/foodcategory/')
        return result.data
    }catch(error){
        return error
    }
} 

export const getSupportListApi=(callback)=>{
    getAxiosTotall().get("support/").then(response =>{
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.data);
        })
};
export const getFactureListApi=(callback)=>{
    getAxiosTotall().get("facture/list/").then(response =>{
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.data);
        })
};
export const getMessageListApi=(id,callback)=>{
    getAxiosTotall().get(`support/${id}`).then(response =>{
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.data);
        })
};

/////////////////  Post Method  ////////////////////

export const AllDiscountProductApi=(info, callback)=>{
    getAxiosTotall().post("products/off/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const postSupportMessage=(info, callback)=>{
    getAxiosTotall().post("support/", info).then(response =>{
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.data);
        })
};
export const postFeedBackApi=(info, callback)=>{
    getAxiosTotall().post("support/feedback/", info).then(response =>{
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.data);
        })
}
export const getProductDetailApi=(info, callback)=>{
    getAxiosTotall().post("products/all/",info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const PostExistFood=(info, callback)=>{
    getAxiosTotall().post("products/update/",info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const postSupportsApi =(info,call)=>{
    getAxiosTotall().post("profile/support/", info).then(response =>{
        call(response.data);
    }).catch(error => {
        call(error.data);
    })
}
export const AddProductsApi =(info,call)=>{
    getAxiosTotall().post("products/add/", info).then(response =>{
        call(response.data);
    }).catch(error => {
        call(error.data);
    })
}
export const removeImageApi =(info,call)=>{
    getAxiosTotall().post("products/removeimage/", info).then(response =>{
        call(response.data);
    }).catch(error => {
        call(error.data);
    })
}
export const AddImageApi =(info,call)=>{
    getAxiosTotall().post("products/addimage/", info).then(response =>{
        call(response.data);
    }).catch(error => {
        call(error.data);
    })
}
export const sendSupplierInfoApi =(info,call)=>{
    getAxiosTotall().post("profile/edit/", info).then(response =>{
        call(response.data);
    }).catch(error => {
        call(error.data);
    })
}
export const sendNotifInfo=(info, callback)=>{
    getAxiosNotif().post("fcm/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}
export const logOutApi=(info, callback)=>{
    getAxiosTotall().post("logout/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}
export const postAddresApi=(info, callback)=>{
    getAxiosTotall().post("profile/editaddress/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}
export const postCategoryFoodApi=(info, callback)=>{
    getAxiosTotall().post("profile/foodcategory/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}
export const cashOutFoodApi=(info, callback)=>{
    getAxiosTotall().post("accounting/cashout/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}
export const changeFactorListPostApi=(info, callback)=>{
    getAxiosTotall().post("orders/changelist/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}
export const createFactureQrCodeAPI=(info, callback)=>{
    getAxiosTotall().post("facture/create/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}
